var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-grow-warp"},[_c('span',{ref:"numberGrow",staticClass:"number-grow",attrs:{"data-time":_vm.time,"data-value":_vm.value}},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }